import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MUTED, NAVY } from "../constants";
import { GaugeRing } from "./GaugeRing";
import { RulesInfoButton } from "./SectionTitle";
import { TrendValue } from "./TrendValue";

export function SummaryCard({ label, value, trend, trendSuffix, inverse = false, icon, accent, ring, rulesKey }) {
  const borderColor = accent || NAVY;
  return (
    <div
      className="rounded-2xl bg-white shadow-sm px-5 py-4"
      style={{ borderLeft: `4px solid ${borderColor}` }}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex min-w-0 items-center gap-1.5">
          <p className="min-w-0 text-[10px] font-bold uppercase tracking-[0.18em]" style={{ color: MUTED }}>
            {label}
          </p>
          <RulesInfoButton title={label} rulesKey={rulesKey} />
        </div>
        {ring !== undefined ? (
          <GaugeRing pct={ring} />
        ) : icon ? (
          <div
            className="w-8 h-8 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{ background: `${borderColor}18` }}
          >
            <FontAwesomeIcon icon={icon} className="text-xs" style={{ color: borderColor }} />
          </div>
        ) : null}
      </div>
      <p className="text-[1.85rem] font-black leading-none tracking-tight" style={{ color: borderColor }}>
        {value}
      </p>
      <div className="mt-2.5 flex items-center gap-1.5 text-[11px]" style={{ color: MUTED }}>
        <TrendValue value={trend} inverse={inverse} />
        <span>{trendSuffix}</span>
      </div>
    </div>
  );
}
